import { z } from 'zod/mini'

export const mainListPageSchema = z.object({
  word: z.optional(z.string()),
  activeCardId: z.optional(z.string()),
})
